import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import usePageContent from '../hooks/usePageContent';
import useContactUs from '../hooks/useContactUs';
import Swal from "sweetalert2";

const schema = yup.object({
    fullName: yup.string().required(),
    email: yup.string().required(),
    phone: yup.string().required(),
    subject: yup.string().required(),
    message: yup.string().required(),
}).required();

const Contact = () => {
    const {
        fetchPageContent,
        data,
        status,
        error,
        resetStatus
    } = usePageContent();

    const {
        addContactUs,
        status: statusContact,
        error: errorContact,
        resetStatus: resetStatusContact
      } = useContactUs();

    const [dataContact, setDataContact] = React.useState([]);

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: "contactUs", field: 'Contact', language: "en-US" });
        }

        if (status === 'done') {
            //console.log(data);
            setDataContact(data === "" ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status])

    const {
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        setValue,
        watch,
        reset: resetForm
    } = useForm({
        resolver: yupResolver(schema), defaultValues: {
            fullName: "",
            email: "",
            phone: "",
            subject: "",
            message: "",
        }
    });

    const {
        onChange: rhfOnChange,
        onBlur,
        name,
        ref: message,
    } = register("message");

    const watchMessage = watch("message");

    const maxLength = 255;

    const onSubmit = (dataForm) => {
        const _data = {
            name: dataForm.fullName,
            email: dataForm.email,
            phone: dataForm.phone,
            subject: dataForm.subject,
            message: dataForm.message
        };
        console.log(_data);
        addContactUs(_data);
    };

    useEffect(() => {
        if (statusContact === 'done') {
            Swal.fire({
                title: "Success",
                text: "Your Custom Request sent successfully, Wait for our response",
                icon: "success",
            });
            resetForm();
        } else if (statusContact === 'error') {
            Swal.fire({
                title: "Error",
                text: errorContact.message,
                icon: "error",
            });
        }
    }, [statusContact])


    const handleChangeBody = (e) => {
        const input = e.target.value
        if (input.length <= maxLength) {
            setValue("message", input);
        }
    }

    return (
        <section className="contact py-80">
            <div className="container container-md">
                <div className="row gy-5">
                    <div className="col-lg-8">
                        <div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <h6 className="mb-32">Contact Request</h6>
                                <div className="row gy-4">
                                    <div className="col-sm-6 col-xs-6">
                                        <label
                                            htmlFor="name"
                                            className="flex-align gap-4 text-sm font-body text-gray-900 fw-semibold mb-4"
                                        >
                                            Full Name{" "}
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <input
                                            {...register("fullName", { required: true })}
                                            type="text"
                                            className="common-input px-16"
                                            id="name"
                                            placeholder="Full name"
                                        />
                                    </div>
                                    <div className="col-sm-6 col-xs-6">
                                        <label
                                            htmlFor="email"
                                            className="flex-align gap-4 text-sm font-body text-gray-900 fw-semibold mb-4"
                                        >
                                            Email Address{" "}
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <input
                                            {...register("email", { required: true })}
                                            type="email"
                                            className="common-input px-16"
                                            id="email"
                                            placeholder="Email address"
                                        />
                                    </div>
                                    <div className="col-sm-6 col-xs-6">
                                        <label
                                            htmlFor="phone"
                                            className="flex-align gap-4 text-sm font-body text-gray-900 fw-semibold mb-4"
                                        >
                                            Phone Number
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <input
                                            {...register("phone", { required: true })}
                                            type="number"
                                            className="common-input px-16"
                                            id="phone"
                                            placeholder="Phone Number*"
                                        />
                                    </div>
                                    <div className="col-sm-6 col-xs-6">
                                        <label
                                            htmlFor="subject"
                                            className="flex-align gap-4 text-sm font-body text-gray-900 fw-semibold mb-4"
                                        >
                                            Subject
                                            <span className="text-danger text-xl line-height-1">
                                                *
                                            </span>{" "}
                                        </label>
                                        <input
                                            {...register("subject", { required: true })}
                                            type="text"
                                            className="common-input px-16"
                                            id="subject"
                                            placeholder="Subject"
                                        />
                                    </div>
                                    <div className="col-sm-12">
                                        <label
                                            htmlFor="message"
                                            className="flex-between gap-4 text-sm font-body text-gray-900 fw-semibold mb-4"
                                        >
                                            <span>
                                                Message
                                                <span className="text-danger text-xl line-height-1">
                                                    *
                                                </span>{" "}
                                            </span>

                                            <span className="text-right text-sm text-gray-500">
                                                {watchMessage.length} / {maxLength}
                                            </span>
                                        </label>
                                        <textarea
                                            onChange={(e) => {
                                                //rhfOnChange(e);          // ✅ react-hook-form stays happy
                                                handleChangeBody(e);  // ✅ your custom logic runs too
                                            }}
                                            className="common-input px-16"
                                            id="message"
                                            placeholder="Type your message"
                                            value={watchMessage}
                                        />
                                    </div>
                                    <div className="col-sm-12 mt-32">
                                        <button
                                            type="submit"
                                            className="btn btn-main-one py-18 px-32 rounded-8"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        {
                            dataContact.map((item, index) => (
                                <div className="contact-box border border-gray-100 rounded-16 px-24 py-40" key={index}>
                                    <h6 className="mb-48">Get In Touch</h6>
                                    <div className="flex-align gap-16 mb-16">
                                        <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-one-600 text-2xl flex-shrink-0">
                                            <i className="ph-fill ph-phone-call" />
                                        </span>
                                        <span
                                            className="text-md text-gray-900 "
                                        >
                                            {item.title}
                                        </span>
                                    </div>
                                    {
                                        item.buttonText !== "" && (
                                            <div className="flex-align gap-16 mb-16">
                                                <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-one-600 text-2xl flex-shrink-0">
                                                    <i className="ph-fill ph-envelope" />
                                                </span>
                                                <span
                                                    className="text-md text-gray-900 "
                                                >
                                                    {item.buttonText}
                                                </span>
                                            </div>
                                        )
                                    }
                                    {
                                        item.description !== "" && (
                                            <div className="flex-align gap-16 mb-0">
                                                <span className="w-40 h-40 flex-center rounded-circle border border-gray-100 text-main-one-600 text-2xl flex-shrink-0">
                                                    <i className="ph-fill ph-map-pin" />
                                                </span>
                                                <span className="text-md text-gray-900 ">
                                                    {item.description}
                                                </span>
                                            </div>
                                        )
                                    }
                                </div>
                            ))
                        }

                        {/* <div className="mt-24 flex-align flex-wrap gap-16">
                            <Link
                                to="#"
                                className="bg-neutral-600 hover-bg-main-one-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
                            >
                                <span className="text-white fw-medium">Get Support On Call</span>
                                <span className="w-36 h-36 bg-main-one-600 rounded-8 flex-center text-xl text-white">
                                    <i className="ph ph-headset" />
                                </span>
                            </Link>
                            <Link
                                to="#"
                                className="bg-neutral-600 hover-bg-main-one-600 rounded-8 p-10 px-16 flex-between flex-wrap gap-8 flex-grow-1"
                            >
                                <span className="text-white fw-medium">Get Direction</span>
                                <span className="w-36 h-36 bg-main-one-600 rounded-8 flex-center text-xl text-white">
                                    <i className="ph ph-map-pin" />
                                </span>
                            </Link>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Contact